<div class="sa-welcome flex">
    <div class="sa-welcome-container h-100">
        <div class="sa-welcome-view h-100 flex-center flex-col">
            <div class="sa-welcome-card-box flex-center flex-col">
                <div class="sa-welcome-logo">
                    <sa-icon class="hidden md-flex" icon="sarasBlue" size="42"></sa-icon>
                    <sa-icon class="md-hidden" icon="sarasBlue" size="80"></sa-icon>
                </div>
                <div class="sa-welcome-title flex">
                    @if (webflowContentReady) {
                    <span class="title">
                        {{LoginSignupPage.pageTitle}}
                    </span>
                    <span class="sub-title">
                        {{LoginSignupPage.pageSubtitle}}
                    </span>
                    }
                </div>
                <div class="sub-title-2">
                    @if (webflowContentReady) {
                    {{LoginSignupPage.pageSubTitle2}}
                    }
                </div>
            </div>
            <div class="sa-welcome-spinner">
                <sa-spinner size="38"></sa-spinner>
                <span class="sa-welcome-spinner-text">Launching now...</span>
            </div>
        </div>
    </div>
</div>